export default "__VITE_ASSET__DhTN0aWf__"